<template>
  <div class="wanshan" v-show="showWanshan">
    <div class="con">
      <div class="tc" v-show="tc">
        <p class="tc_tit">
          小提示 <span class="fr clearfix closed cur" @click="closed"></span>
        </p>
        <span
          class="inline"
          style="height: 30px; line-height: 30px; margin-bottom: 20px"
          >有需要完善的资料</span
        >
        <p style="font-size: 14px; font-weight: bold" v-show="form">
          《中国质量协会第十届理事会副会长人选推荐登记表》
          <router-link class="fr clearfix" to="/form">去完善</router-link>
        </p>
        <p style="font-size: 14px; font-weight: bold" v-show="appoint">
          《理事会副会长干部任免表》
          <router-link class="fr clearfix" to="/appoint">去完善</router-link>
        </p>
      </div>
      <p class="con_tit"><span></span><strong>完善理事资料</strong></p>
      <div class="con_con">
        <div class="dws" @click="get_type">
          <img class="fl clearfix" src="../../static/img/icon9.png" />
          <div class="fl clearfix">
            <p style="line-height: 25px">{{ zhiwei }}</p>
            <span :class="color == 1 ? 'red' : ''">{{ ziliao }}</span>
          </div>
        </div>
        <ul class="list">
          <span class="list_tit">已完善资料</span>
          <li v-show="dengJi" v-for="(item, index) in arr1">
            提交时间{{
              item.created_at.split(" ")[0]
            }}
            &nbsp;&nbsp;中国质量协会第{{ item.which }}届理事会{{
              item.director_title
            }}候选人推荐登记表-{{ item.name }}
            <a
              class="to_table"
              style="cursor: pointer"
              @click="to_table1(item.director_id)"
              >查看</a
            >
          </li>
          <li v-show="renMian" v-for="(item, index) in arr2">
            提交时间{{
              item.created_at.split(" ")[0]
            }}
            &nbsp;&nbsp;中国质量协会第{{
              item.which
            }}届理事会副会长任免审批表-{{ item.name }}
            <a
              class="to_table1"
              style="cursor: pointer"
              @click="to_table2(item.id)"
              >查看</a
            >
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import Qs from 'qs'
export default {
  data () {
    return {
      color: 1,
      form: true,
      appoint: true,

      dengJi: false,
      renMian: false,
      zhiwei: '',
      ziliao: '',
      tc: false,
      arr1: [],
      arr2: [],
    };
  },
  props: {
    showWanshan: {
      type: Boolean
    }
  },
  created () { },
  mounted () {
    if (sessionStorage.getItem('Token')) {
      var token = sessionStorage.getItem('Token');
    };
    var data1 = {
      'access-token': token
    };
    this.$axios({
      method: 'post',
      url: 'director/directorinfo',
      data: Qs.stringify(data1)
    }).then(response => {
      console.log(response.data);
      if (response.data.state == 3) {
        if (response.data.data.length != 0) {
          this.dengJi = true;
          this.arr1 = response.data.data;
        };
        if (response.data.dismiss.length != 0) {
          this.renMian = true;
          this.arr2 = response.data.dismiss;
        };

      }
    });

    this.$axios({
      method: 'post',
      url: 'director/status',
      data: Qs.stringify(data1)
    }).then(response => {
      console.log(response.data);
      if (response.data.state == 1) {
        sessionStorage.setItem('ziliao', response.data.token.task_status);
      }

    })

    if (sessionStorage.getItem('type')) {
      switch (Number(sessionStorage.getItem('type'))) {
        case 2:
          //企业用户判断理事类型
          switch (Number(sessionStorage.getItem('zhiwei'))) {
            case 0:
              break;
            case 1:
              //理事
              this.zhiwei = '第十一届理事信息登记表';
              if (sessionStorage.getItem('ziliao') == 2) {
                this.color = 2;
                this.ziliao = '已完善';
              } else {
                this.ziliao = '待完善';

              }
              break;
            case 2:
              //常务理事
              this.zhiwei = '理事会常务理事候选人推荐登记表';
              if (sessionStorage.getItem('ziliao') == 2) {
                this.color = 2;
                this.ziliao = '已完善';
              } else {
                this.ziliao = '待完善';
              }
              break;
            case 3:
              //副会长
              this.zhiwei = '理事会副会长候选人推荐登记表';
              switch (Number(sessionStorage.getItem('ziliao'))) {
                case 0:
                  this.ziliao = '待完善';
                  break;
                case 1:
                  this.ziliao = '待完善';
                  break;
                case 2:
                  this.color = 2;
                  this.ziliao = '已完善';
                  break;
                case 3:
                  this.ziliao = '待完善';
                  this.form = false;
                  break;
                case 4:
                  this.ziliao = '待完善';
                  this.appoint = false;
                  break;
              }
              break;
          };
          break;
        case 4:
          //特邀 常务理事
          this.zhiwei = '理事会常务理事候选人推荐登记表';
          if (sessionStorage.getItem('ziliao') == 2) {
            this.color = 2;
            this.ziliao = '已完善';
          } else {
            this.ziliao = '待完善';
          }
          break;
        case 5:
          //特邀 副会长
          this.zhiwei = '理事会副会长候选人推荐登记表';
          switch (Number(sessionStorage.getItem('ziliao'))) {
            case 0:
              this.ziliao = '待完善';
              break;
            case 1:
              this.ziliao = '待完善';
              break;
            case 2:
              this.color = 2;
              this.ziliao = '已完善';
              break;
            case 3:
              this.ziliao = '待完善';
              this.form = false;
              break;
            case 4:
              this.ziliao = '待完善';
              this.appoint = false;
              break;
            //弹窗
          }
          break;
      }
    };

  },
  methods: {
    closed () {
      this.tc = false;
    },
    to_table1 (id) {
      sessionStorage.setItem('dengJi_id', id);
      this.$router.push('/table');
    },
    to_table2 (id) {
      sessionStorage.setItem('renMian_id', id);
      this.$router.push('/table1');
    },
    get_type () {
      if (sessionStorage.getItem('type')) {
        switch (Number(sessionStorage.getItem('type'))) {
          case 2:
            //企业用户判断理事类型

            switch (Number(sessionStorage.getItem('zhiwei'))) {
              case 0:
                break;
              case 1:
                //理事
                if (sessionStorage.getItem('ziliao') == 1 || sessionStorage.getItem('ziliao') == 0) {
                  this.$router.push('/form');
                } else {
                  this.$toast('您没有待完善的资料')
                }
                break;
              case 2:
                //常务理事
                if (sessionStorage.getItem('ziliao') == 1 || sessionStorage.getItem('ziliao') == 0) {
                  this.$router.push('/form');
                } else {
                  this.$toast('您没有待完善的资料');
                }
                break;
              case 3:
                //副会长
                switch (Number(sessionStorage.getItem('ziliao'))) {
                  case 0:
                    this.tc = true;
                    break;
                  case 1:
                    this.tc = true;
                    break;
                  case 2:
                    this.$toast('您没有待完善的资料');
                    break;
                  case 3:
                    this.tc = true;
                    break;
                  case 4:
                    this.tc = true;

                    break;
                  //弹窗
                }
                break;
            };
            break;
          case 4:
            //特邀 常务理事
            if (sessionStorage.getItem('ziliao') == 1 || sessionStorage.getItem('ziliao') == 0) {
              this.$router.push('/form');
            } else {
              this.$toast('您没有待完善的资料')
            }
            break;
          case 5:
            //特邀 副会长
            switch (Number(sessionStorage.getItem('ziliao'))) {
              case 0:
                //都没完善
                this.tc = true;
                break;
              case 1:
                //都没完善
                this.tc = true;
                break;
              case 2:
                this.$toast('您没有待完善的资料');
                break;
              case 3:
                //任免
                this.tc = true;
                break;
              case 4:
                //登记
                this.tc = true;
                break;
              //弹窗
            }
            break;
        }
      };
    },
  }
}
</script>
<style scoped>
.red {
  color: #ff2c46;
  font-weight: bold;
}
.tc {
  padding: 15px;
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 384px;
  height: 160px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.15);
  border-radius: 4px;
  border: 1px solid #cecece;
  z-index: 99;
}
.tc_tit {
  width: 100%;
  height: 30px;
  line-height: 30px;
  font-size: 16px;
  font-weight: bold;
}
.closed {
  width: 15px;
  height: 15px;
  background: url(../../static/img/close.png) no-repeat;
  background-size: 100%;
}
.tc a {
  color: #0076ff;
}
.clearfix::after {
  content: ".";
  clear: both;
  visibility: hidden;
  height: 0;
  display: block;
  line-height: 0;
}

.clearfix {
  zoom: 1;
}

.fl {
  float: left;
}

.fr {
  float: right;
}

.inline {
  display: inline-block;
}

.v_middle {
  vertical-align: middle;
}

.w50 {
  width: 49%;
}

.cur {
  cursor: pointer;
}

.rap {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.flex {
  display: flex;
  align-items: center;
  justify-content: center;
}

.wanshan {
  width: 100%;
  height: auto;
  background: #fff;
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #404040;
  text-align: left;
}

.con {
  width: 100%;
  height: auto;
  position: relative;
}

.con_tit {
  padding-left: 30px;
  color: #005eb3;
  font-size: 18px;
  line-height: 45px;
  font-weight: bold;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.con_tit span {
  width: 4px;
  height: 16px;
  background: #4799e4;
  margin-right: 7px;
}

.con_con {
  width: 100%;
  height: 760px;
  box-sizing: border-box;
  padding: 45px 45px 0 30px;
}

.dws {
  padding: 17px 0 17px 19px;
  width: 280px;
  height: 80px;
  background: rgba(0, 118, 255, 1);
  color: #fff;
  box-sizing: border-box;
  margin-bottom: 74px;
}

.dws img {
  width: 36px;
  height: 46px;
  margin-right: 10px;
}

.list {
  padding: 20px;
  position: relative;
  width: 874px;
  height: 250px;
  background: rgba(255, 255, 255, 1);
  border: 1px solid rgba(122, 184, 226, 1);
  box-sizing: border-box;
}
.list a {
  float: right;
  color: #0076ff;
}
.list_tit {
  color: #fff;
  width: 96px;
  height: 30px;
  background: rgba(0, 94, 179, 1);
  position: absolute;
  top: -15px;
  left: 18px;
  text-align: center;
  line-height: 30px;
}
</style>


// WEBPACK FOOTER //
// src/components/Wanshan.vue